// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"FoodList--next-sr-only--28UgRyR","title":"FoodList--title--1C_X_Ge","box":"FoodList--box--UOVLGIq","text":"FoodList--text--zmqxzI-","btn":"FoodList--btn--2ZL6Rxf"};